<template lang='pug'>
//- Register-Form
div(:class='$style[`cc-register-form`]')

  div(:class='[$style[`cc-form-content`], [$style[isDoctor ? `cc-form-doctor` : `cc-form-normal`]]]')
    div(:class='$style[`cc-form-content-left`]')
      //- 我是醫生介紹
      div(v-if='isDoctor' :class='$style[`cc-left-block`]')
        figure.img2x(:class='$style[`cc-content-bg`]')
        div(:class='$style[`cc-content-describe`]')
          span(:class='[`font-bold`, $style[`cc-content-title`]]') 醫護會員功能
          ul(:class='$style[`cc-content-list`]')
            li
              IconAgree(:size='24' :color='`#fff`')
              span 使用管理後台
            li
              IconFriend(:size='24' :color='`#fff`')
              span 成為合作廠商
            li
              IconFollowDoctor(:size='24' :color='`#fff`')
              span 遠距線上諮詢
            li
              IconBookMark(:size='24' :color='`#fff`')
              span 刊登衛教課程

      //- 一般會員介紹
      div(v-if='isNormal' :class='$style[`cc-left-block`]')
        figure.img2x(:class='$style[`cc-content-bg`]')
        div(:class='$style[`cc-content-describe`]')
          span(:class='[`font-bold`, $style[`cc-content-title`]]') 一般會員功能
          ul(:class='$style[`cc-content-list`]')
            li
              IconLike(:size='24' :color='`#fff`')
              span 使用Dr.Cell Ai服務
            li
              IconFollowDoctor(:size='24' :color='`#fff`')
              span 免費線上諮詢
            li
              IconResumeCard(:size='24' :color='`#fff`')
              span ePRO癌症照護
            li
              IconBookMark(:size='24' :color='`#fff`')
              span 抗癌課程與社群

    div(:class='$style[`cc-form-content-right`]')
      div(:class='$style[`cc-content-new`]')
        button(
          tabindex='0' aria-label='快速登入 / 註冊'
          :class='$style[`cc-content-line-login-btn`]'
          @click='handleClickLineAuthorize(isDoctor ? `doctor` : `normal`)')
          IconLine(:size='36')
          span 快速登入 / 註冊

        span(:class='$style[`cc-form-content-divider`]') 或者
        //- button(
        //-   tabindex='0'
        //-   aria-label='使用Line快速註冊'
        //-   @click='handleClickLineAuthorize(`normal`)') 使用Line快速註冊
        //- div(:class='$style[`cc-content-new-title`]')
        //-   span!= '註冊新會員'
        Inputer(
          title='手機 / 信箱'
          v-model.trim='formConfig.status.accountValue'
          :class='$style[`cc-content-new-input`]'
          :resetButton='false'
          :placehold='`手機 / 信箱 (二擇一)`'
          :beforeIcon='`mail`'
          :beforeIconSize='24'
          :beforeIconColor='`#d0d0d0`'
          :type='`email`'
          :errorRegex='formConfig.verify.accountRegexError'
          :errorRegexInfo='formConfig.verify.accountErrorLog'
          :errorValue='formConfig.verify.accountError'
          @clearErrorMsg="(value) => {this.formConfig.verify.accountError = value[0]; this.formConfig.verify.accountRegexError = value[1];}")

          //- :keyPressEnter='handleCheckProgressBeforeSend'

        Inputer(
          title='會員密碼'
          v-model.trim='formConfig.status.passwordValue'
          :class='$style[`cc-content-new-input`]'
          :resetButton='false'
          :placehold='`大於5字英數組合密碼`'
          :beforeIcon='`password`'
          :beforeIconSize='24'
          :beforeIconColor='`#d0d0d0`'
          :type='`password`'
          :errorRegex='formConfig.verify.passwordRegexError'
          :errorRegexInfo='formConfig.verify.passwordErrorLog'
          :errorValue='formConfig.verify.passwordError'
          @clearErrorMsg="(value) => {this.formConfig.verify.passwordError = value[0]; this.formConfig.verify.passwordRegexError = value[1];}")

        div(:class='$style[`cc-content-user-info`]')
          Inputer(
            title='姓氏'
            style='margin-right: 10px; width: 32%;'
            v-model.trim='formConfig.status.firstNameValue'
            :class='$style[`cc-content-new-input`]'
            :resetButton='false'
            :placehold='`姓氏`'
            :beforeIcon='`user`'
            :beforeIconSize='24'
            :beforeIconColor='`#d0d0d0`'
            :type='`user`'
            :errorRegex='formConfig.verify.firstNameRegexError'
            :errorRegexInfo='formConfig.verify.firstNameErrorLog'
            :errorValue='formConfig.verify.firstNameError'
            @clearErrorMsg="(value) => {this.formConfig.verify.firstNameError = value[0]; this.formConfig.verify.firstNameRegexError = value[1];}")

          Inputer(
            title='名字'
            v-model.trim='formConfig.status.lastNameValue'
            style='margin-right: 10px; width: 28%;'
            :class='$style[`cc-content-new-input`]'
            :resetButton='false'
            :defaultValue='``'
            :placehold='`名字`'
            :type='`user`'
            :errorRegex='formConfig.verify.lastNameRegexError'
            :errorRegexInfo='formConfig.verify.lastNameErrorLog'
            :errorValue='formConfig.verify.lastNameError'
            @clearErrorMsg="(value) => {this.formConfig.verify.lastNameError = value[0]; this.formConfig.verify.lastNameRegexError = value[1];}")

          Select(
            title='選擇性別'
            v-model='formConfig.status.genderValue'
            style='width: 41%;'
            :class='$style[`cc-content-new-select`]'
            :placehold='`性別`'
            :beforeIcon='`gender`'
            :beforeIconSize='24'
            :beforeIconColor='`#d0d0d0`'
            :optionList='[`先生`, `小姐`]'
            :errorValue='formConfig.verify.genderError'
            @sendSelectValue='setGenderSelectValue'
            @clearErrorMsg="(value) => {this.formConfig.verify.genderError = value}")

        div(v-if='isDoctor' :class='$style[`cc-content-user-info`]')
          Select(
            v-model='formConfig.status.characterValue'
            title='選擇醫護身份'
            :class='$style[`cc-content-new-select`]'
            :placehold='`醫護身份`'
            :beforeIcon='`cure`'
            :beforeIconSize='24'
            :beforeIconColor='`#d0d0d0`'
            :optionList='[`主治醫師`, `護理師`, `個管師`, `營養師`, `物理治療師`, `職能治療師`, `語言治療師`, `藥劑師`, `心理師`, `社工師`]'
            :errorValue='formConfig.verify.characterError'
            @sendSelectValue='setCharacterSelectValue'
            @clearErrorMsg="(value) => {this.formConfig.verify.characterError = value}")

          //- Inputer(
          //-   v-if='otherProfessionShow'
          //-   v-model='formConfig.status.characterValue'
          //-   title='填寫完整癌症全名'
          //-   style='margin-left: 10px;'
          //-   :class='[$style[`cc-content-new-input`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
          //-   :resetButton='false'
          //-   :defaultValue='``'
          //-   :placehold='`範例:某某癌`'
          //-   :errorValue='formConfig.verify.characterError'
          //-   @clearErrorMsg="(value) => {this.formConfig.verify.characterError = value[0];}")

        //- div(v-if='isDoctor' :class='$style[`cc-content-user-info`]')
        //-   Select(
        //-     v-model='formConfig.status.professionValue'
        //-     title='選擇關注的癌症類型'
        //-     :class='[$style[`cc-content-new-input`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
        //-     :placehold='`關注的癌症`'
        //-     :beforeIcon='`helper`'
        //-     :beforeIconSize='24'
        //-     :beforeIconColor='`#d0d0d0`'
        //-     :optionList='CANCER_TYPE'
        //-     :errorValue='formConfig.verify.professionError'
        //-     @sendSelectValue='setProfessionSelectValue'
        //-     @clearErrorMsg="(value) => {this.formConfig.verify.professionError = value}")

        //-   Inputer(
        //-     v-if='otherProfessionShow'
        //-     v-model='formConfig.status.professionValue'
        //-     title='填寫完整癌症全名'
        //-     style='margin-left: 10px;'
        //-     :class='[$style[`cc-content-new-input`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
        //-     :resetButton='false'
        //-     :defaultValue='``'
        //-     :placehold='`範例:某某癌`'
        //-     :errorValue='formConfig.verify.professionError'
        //-     @clearErrorMsg="(value) => {this.formConfig.verify.professionError = value[0];}")

        div(:class='$style[`cc-content-check-privacy`]')
          CheckBox(
            :errorValue='formConfig.verify.readPrivacyError'
            :labelText='`我已閱讀並同意<a href="${NODE_DOMAIN}/termUsage" target="_blank" rel="noreferrer" title="使用者條款">使用者條款</a>與<a href="${NODE_DOMAIN}/privacy" target="_blank" rel="noreferrer" title="隱私政策">隱私政策</a>`'
            @sendCheckStatus='setPrivacyCheckBoxStatus'
            @clearErrorMsg="(value) => {this.formConfig.verify.readPrivacyError = value}")
            //- a(href='#')

        button(
          title='確認送出'
          tabindex='0'
          :aria-label='showLoading ? `處理中` : `確認送出`'
          @click='handleCheckProgressBeforeSend'
          :class='$style[`cc-content-new-send`]')
          IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
          span {{ showLoading ? `處理中` : `確認送出`}}

        div(:class='$style[`cc-google-recaptcha`]')
          span 表單採用
          a(href='//developers.google.com/recaptcha' target='_blank' rel='noreferrer' title="Google reCAPTCHA") Google reCAPTCHA
          span 保護。
          a(href='//policies.google.com/privacy?hl=zh-TW' target='_blank' rel='noreferrer' title="隱私權") 隱私權
          span  - 
          a(href='//policies.google.com/terms?hl=zh-TW' target='_blank' rel='noreferrer' title="條款") 條款

      //- div(:class='$style[`cc-content-fast`]')
      //-   div(:class='$style[`cc-content-fast-title`]')
      //-     span!= '快速註冊'
      //-   div(:class='$style[`cc-fast-list`]')
      //-     a(:class='[$style[`cc-fast-link`], $style[`cc-link-fb`]]' href='#' title='facebook 快速註冊')
      //-       IconFacebook(:size='24' :color='`#fff`')
      //-     a(:class='[$style[`cc-fast-link`], $style[`cc-link-google`]]' href='#' title='Google+ 快速註冊')
      //-       IconGooglePlus(:size='24' :color='`#fff`')


</template>

<script>
import IconAgree from '../../icon/Agree';
import IconFriend from '../../icon/Friend';
import IconBookMark from '../../icon/Bookmark';
import IconLike from '../../icon/Like';
import IconFollowDoctor from '../../icon/FollowDoctor';
import IconResumeCard from '../../icon/ResumeCard';
// import IconFacebook from '../../icon/Facebook';
// import IconGooglePlus from '../../icon/GooglePlus';
import IconLoading from '../../icon/Loading';
import IconLine from '../../icon/Line';

import Inputer from '../common/Input';
import Select from '../common/Select';
import CheckBox from '../common/Checkbox';

// import axios from 'axios';
import { 
  postRegisterMember,
  postDjangoSuperMember,
  getDjangoAllTypeMember,
} from '../../../js/restapi';

import qs from 'qs';

import Vue from 'vue';
import { mapMutations } from 'vuex';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { v4 as uuidv4 } from 'uuid';
Vue.use(VueReCaptcha, { siteKey: '6LfTMuEUAAAAACAfKn6NNHi2O38xBJ3VvEv_aF7i' });

export default {
  components: {
    IconAgree,
    IconFriend,
    IconBookMark,
    IconLike,
    IconFollowDoctor,
    IconResumeCard,
    IconLine,
    // IconFacebook,
    // IconGooglePlus,
    IconLoading,

    Inputer,
    Select,
    CheckBox,
  },

  props: {
    isDoctor: {
      type: Boolean,
      default: false,
    },
    isNormal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showLoading: false,
      otherProfessionShow: false,
      formAccountType: '',
      formConfig: {
        status: {
          accountValue: '',
          passwordValue: '',
          firstNameValue: '',
          LastNameValue: '',
          genderValue: '',
          professionValue: '',
          characterValue: '',
          readPrivacyValue: false,
        },
        verify: {
          accountRegexError: false,
          accountErrorLog: '',
          accountError: false,

          passwordRegexError: false,
          passwordErrorLog: '請輸入英文數字組合並至少6個字',
          passwordError: false,

          firstNameError: false,
          firstNameRegexError: false,
          firstNameErrorLog: '限中文',

          lastNameError: false,
          lastNameRegexError: false,
          lastNameErrorLog: '限中文',

          genderError: false,
          professionError: false,
          characterError: false,
          readPrivacyError: false,
        },
        verifyAllPass: true,
      },
    };
  },

  methods: {
    async recaptcha() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('login');
      // const recaptcha = this.$recaptchaInstance;
      // recaptcha.hideBadge();
    },

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
    }),

    handleClickLineAuthorize(user_type) {
      window.location = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.LINE_LOGIN_ID}&redirect_uri=${this.LINE_LOGIN_DOMAIN}/line/authorize&state=${user_type}&scope=openid%20profile&nonce=helloWorld&prompt=consent&ui_locales=zh-TW`;
    },

    setGenderSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '先生' ? this.formConfig.status.genderValue = 0 : this.formConfig.status.genderValue = 1;
    },

    setCharacterSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      this.formConfig.status.characterValue = value;
    },

    setPrivacyCheckBoxStatus(value) {
      // eslint-disable-next-line no-unused-expressions
      value === 'checked' ? this.formConfig.status.readPrivacyValue = true : this.formConfig.status.readPrivacyValue = false;
    },

    // setProfessionSelectValue(value) {
    //   // eslint-disable-next-line no-unused-expressions
    //   if (value === '填寫其他') {
    //     this.otherProfessionShow = true;
    //     this.formConfig.status.professionValue = '';
    //   } else {
    //     this.otherProfessionShow = false;
    //     this.formConfig.status.professionValue = value;
    //   }
    // },

    handleFormsCheckToPass() {
      this.formConfig.verifyAllPass = true;
      // Email格式Regex
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      // 姓氏與姓名不是中文
      const chinesePattern = new RegExp(/[\u4e00-\u9fa5]$/);
      const phonePattern = new RegExp(/^09\d{8}$/);
      // PassWord必須有 英文+數字且超過6字元
      const passWordPattern = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[a-zA-Z\d]{6,}$/);

      if (this.formConfig.status.accountValue) {
        if (this.formConfig.status.accountValue.match(emailPattern)) {

          // (Auth Step-1) 檢查Email是否已被註冊
          getDjangoAllTypeMember(`?oauth=${this.formConfig.status.accountValue}`)
            .then((response) => {
              if (!response.data.count) {
                this.formAccountType = 'email';
                this.handleConnectDjangoWithApi();
              } else {
                this.formConfig.verify.accountRegexError = true;
                this.formConfig.verify.accountError = true;
                this.formConfig.verify.accountErrorLog = '抱歉，信箱已被註冊';
                this.formConfig.verifyAllPass = false;
              }
            })
            .catch((error) => {
              console.log('Axios getDjangoAllTypeMember Error', error.response);
            });
        } else if (this.formConfig.status.accountValue.match(phonePattern)) {
          // (Auth Step-1) 檢查Email是否已被註冊
          getDjangoAllTypeMember(`?oauth=${this.formConfig.status.accountValue}`)
            .then((response) => {
              if (!response.data.count) {
                this.formAccountType = 'phone';
                this.handleConnectDjangoWithApi();
              } else {
                this.formConfig.verify.accountRegexError = true;
                this.formConfig.verify.accountError = true;
                this.formConfig.verify.accountErrorLog = '抱歉，手機號碼已被註冊';
                this.formConfig.verifyAllPass = false;
              }
            })
            .catch((error) => {
              console.log('Axios getDjangoAllTypeMember Error', error.response);
            });
        } else {
          this.formConfig.verify.accountRegexError = true;
          this.formConfig.verify.accountError = true;
          this.formConfig.verify.accountErrorLog = '格式錯誤(範例: 0912345678、mail@cancell.com)';
          this.formConfig.verifyAllPass = false;
        }

        // // (Auth Step-1) 檢查Email是否已被註冊
        // getDjangoAllTypeMember(`?email=${this.formConfig.status.accountValue}`)
        //   .then((response) => {
        //     if (!response.data.count) {
        //       // (Auth Step-1) PASS > 檢查信箱格式是否有誤
        //       if (!this.formConfig.status.accountValue.match(emailPattern)) {
        //         console.log('註冊 Auth Step-1:: A', this.formConfig.verifyAllPass);
        //         this.formConfig.verify.accountRegexError = true;
        //         this.formConfig.verify.accountError = true;
        //         this.formConfig.verify.accountErrorLog = '信箱格式不正確';
        //         this.formConfig.verifyAllPass = false;
        //       } else {
        //         this.handleConnectDjangoWithApi();
        //       }
        //     } else {
        //       this.formConfig.verify.accountRegexError = true;
        //       this.formConfig.verify.accountError = true;
        //       this.formConfig.verify.accountErrorLog = '抱歉，此信箱已被註冊';
        //       this.formConfig.verifyAllPass = false;
        //       console.log('Auth Step-1:: Email已被註冊! Failed');
        //     }
        //   })
        //   .catch((error) => {
        //     console.log('Axios getDjangoAllTypeMember Error', error.response);
        //   });
      } else {
        // 信箱為空
        this.formConfig.verify.accountError = true;
        this.formConfig.verifyAllPass = false;
      }
      // 驗證密碼欄位為空
      if (this.formConfig.status.passwordValue) {
        if (!this.formConfig.status.passwordValue.match(passWordPattern)) {
          // console.log('密碼沒英文跟數字!');
          this.formConfig.verify.passwordRegexError = true;
          this.formConfig.verify.passwordError = true;
          this.formConfig.verifyAllPass = false;
        }
      } else {
        this.formConfig.verify.passwordError = true;
        this.formConfig.verifyAllPass = false;
      }
      // 驗證姓氏欄位為空
      if (this.formConfig.status.firstNameValue) {
        if (!this.formConfig.status.firstNameValue.match(chinesePattern)) {
          // console.log('偵測不是中文!!');
          this.formConfig.verify.firstNameError = true;
          this.formConfig.verify.firstNameRegexError = true;
          this.formConfig.verifyAllPass = false;
        } else if (this.formConfig.status.firstNameValue.length > 2) {
          this.formConfig.verify.firstNameError = true;
          this.formConfig.verify.firstNameRegexError = true;
          this.formConfig.verify.firstNameErrorLog = '限2字';
          this.formConfig.verifyAllPass = false;
        }
      } else {
        this.formConfig.verify.firstNameError = true;
        this.formConfig.verifyAllPass = false;
      }
      // 驗證名字欄位為空
      if (this.formConfig.status.lastNameValue) {
        if (!this.formConfig.status.lastNameValue.match(chinesePattern)) {
          // console.log('偵測不是中文!!');
          this.formConfig.verify.lastNameError = true;
          this.formConfig.verify.lastNameRegexError = true;
          this.formConfig.verifyAllPass = false;
        } else if (this.formConfig.status.lastNameValue.length > 2) {
          this.formConfig.verify.lastNameError = true;
          this.formConfig.verify.lastNameRegexError = true;
          this.formConfig.verify.lastNameErrorLog = '限2字';
          this.formConfig.verifyAllPass = false;
        }
      } else {
        this.formConfig.verify.lastNameError = true;
        this.formConfig.verifyAllPass = false;
      }
      // 驗證性別欄位為空
      if (this.formConfig.status.genderValue === '') {
        this.formConfig.verify.genderError = true;
        this.formConfig.verifyAllPass = false;
      }

      // 驗證身份欄位為空
      if (this.isDoctor && this.formConfig.status.characterValue === '') {
        this.formConfig.verify.characterError = true;
        this.formConfig.verifyAllPass = false;
      }

      // 驗證主治癌症類型欄位為空
      // if (this.isDoctor && this.formConfig.status.professionValue === '') {
      //   this.formConfig.verify.professionError = true;
      //   this.formConfig.verifyAllPass = false;
      // }

      // 驗證隱私權與使用提款是否已讀
      if (!this.formConfig.status.readPrivacyValue) {
        this.formConfig.verify.readPrivacyError = true;
        this.formConfig.verifyAllPass = false;
      }
    },

    createDjangoSuperMember(postData) {
      // let userNameFromEmail = postData.email.substring(0, postData.email.indexOf('@'));
      // Create Django Super User

      postDjangoSuperMember('usersuper', qs.stringify({
        oauth: postData.oauth,
        email: postData.email,
        phone: postData.phone,
        password: postData.password,
        hashcode: postData.hashcode,
        user_type: postData.user_type,
      }))
        .then((response) => {
          console.log('註冊 Auth Step-3:: Djongo DB新增Super會員，Pass!', response.data);

          // 註冊成功後刪除JWT以及Vuex JWT並登入
          localStorage.removeItem('cc-jwt');
          this.changeAuthJwtToken(null);
          this.changePopBoxStatus({
            active: true,
            include: 'registerConfirm',
          });

          setTimeout(() => {
            this.showLoading = false;
            this.changePopBoxStatus({
              active: true,
              include: 'login',
            });
          }, this.POP_DURATION);
        })
        .catch((error) => {
          console.log('Axios registerDjangoSuperMember Error', error.response);
        });
    },

    createAuthMember(postData, apiUrl) {
      // Create Doctor or Normal User To DB
      postRegisterMember(apiUrl, qs.stringify(postData))
        .then((response) => {
          console.log('註冊 Auth Step-2:: DB新增會員，Pass!', response.data);
          this.createDjangoSuperMember(postData);
        })
        .catch((error) => {
          console.log('Axios postRegisterMember Error', error.response);
        });
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      console.log('aaaaaa', this.formConfig.verifyAllPass);
      if (!this.formConfig.verifyAllPass) { return; }
      // API_URl
      const API_URL = this.isDoctor ? 'doct' : 'user';

      const userTypeSwitch = new Promise((resolve) => {
        let POST_DATA = {};

        if (this.isDoctor) {
          // eslint-disable-next-line no-const-assign
          POST_DATA = {
            user_type: 'doctor',
            oauth: this.formConfig.status.accountValue,
            email: this.formAccountType === 'email' ? this.formConfig.status.accountValue : '',
            phone: this.formAccountType === 'phone' ? this.formConfig.status.accountValue : '',
            password: this.formConfig.status.passwordValue,
            firstName: this.formConfig.status.firstNameValue,
            lastName: this.formConfig.status.lastNameValue,
            gender: this.formConfig.status.genderValue,
            profession: this.formConfig.status.professionValue,
            character: this.formConfig.status.characterValue,
            hashcode: uuidv4(),
          };
        } else {
          // eslint-disable-next-line no-const-assign
          POST_DATA = {
            user_type: 'normal',
            oauth: this.formConfig.status.accountValue,
            email: this.formAccountType === 'email' ? this.formConfig.status.accountValue : '',
            phone: this.formAccountType === 'phone' ? this.formConfig.status.accountValue : '',
            password: this.formConfig.status.passwordValue,
            firstName: this.formConfig.status.firstNameValue,
            lastName: this.formConfig.status.lastNameValue,
            gender: this.formConfig.status.genderValue,
            hashcode: uuidv4(),
          };
        }
        return resolve(POST_DATA);
      });

      userTypeSwitch.then((value) => {
        console.log('userTypeSwitch', value);
        this.showLoading = true;
        this.createAuthMember(value, API_URL);
      });
    },

    // Send Button OnClick
    handleCheckProgressBeforeSend() {
      this.handleFormsCheckToPass();
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/registerForm.scss';
</style>
